import { render } from "./CurateProfile.vue?vue&type=template&id=c3249552&scoped=true"
import script from "./CurateProfile.vue?vue&type=script&lang=js"
export * from "./CurateProfile.vue?vue&type=script&lang=js"

import "./CurateProfile.vue?vue&type=style&index=0&id=c3249552&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3249552"]])

export default __exports__